import React from "react";
import { useLocation } from "react-router-dom";
import { Edit } from "iconsax-react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import convertDateToString from "../../../../../libs/convertDateToString";

import {
  StyledImageSection,
  UploadedImageWrapper,
} from "../../labReport/styledLabReport";
import { TitleBox } from "../styledActivityTab";
import { StyledReportHeader } from "./styledReportData";
import { Spinner } from "react-bootstrap";

const LabReportDataComponent = ({
  lastEdit,
  handleGoBack,
  editorContent,
  uploadedImages,
  lastEditLoading,
}) => {
  const location = useLocation();
  const lastEditReport = convertDateToString("string", lastEdit);

  return (
    <>
      <StyledReportHeader className="w-100 m-0 mb-md-1">
        <TitleBox className="lab-report-title text-center pt-2">
          گزارش کار
          {location.state?.editFromProfile && (
            <Edit
              className="edit-icon"
              color="var(--primary-color)"
              onClick={handleGoBack}
            />
          )}
        </TitleBox>
        <span className="date-box text-center pt-1">
          {lastEditLoading ? (
            <Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
              size="sm"
            />
          ) : (
            <>
              {`${lastEditReport.day} ${lastEditReport.month} ${lastEditReport.year}`}
            </>
          )}
        </span>
      </StyledReportHeader>
      {editorContent.map((item) => (
        <div key={item.id}>
          <label className="align-self-start">{item.label}</label>
          <CKEditor
            data={`${item.value}`}
            editor={ClassicEditor}
            disabled={true}
            config={{
              toolbar: [],
              isReadOnly: true,
              language: "ar",
            }}
          />
        </div>
      ))}
      <StyledImageSection className="mt-3" $displayGrid={true}>
        {uploadedImages?.map((image) => (
          <UploadedImageWrapper key={image.id}>
            <img
              className="uploaded-image"
              src={image.src}
              alt="uploaded-image"
              width="100%"
              height="100%"
            />
          </UploadedImageWrapper>
        ))}
      </StyledImageSection>
    </>
  );
};

export default LabReportDataComponent;
